require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-393-migrating-ants.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-393-migrating-ants");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-393-migrating-ants!./.cache/json/coding-interview-prep-project-euler-problem-393-migrating-ants.json
// module id = 1682
// module chunks = 231608221292675